import React from 'react';
import TableCellSkeleton from '../TableCellSkeleton/TableCellSkeleton';
import Tooltip from '@app/react-common/components/tooltip/Tooltip';

interface TableCellProps {
  value?: string;
  className?: string;
  children?: JSX.Element;
  isLoading?: boolean;
  ellipsis?: boolean;
}

export default function TableCell({ value, className, children, isLoading = false, ellipsis }: TableCellProps) {
  let elementToRender = isLoading ? <TableCellSkeleton /> : children || value;

  if (ellipsis && value) {
    elementToRender = (
      <Tooltip tooltipText={value}>
        <div className="generic-metrics-table-cell__ellipsis">{value}</div>
      </Tooltip>
    );
  }

  return <div className={`generic-metrics-table-cell ${className || ''}`}>{elementToRender}</div>;
}
